export default "__VITE_ASSET__CcKc8ZDd__"